import { FC, useEffect, useState } from "react";
import { tutorService } from "../../../entities/tutor";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { useMyActions } from "../../../entities/my";
import { MyError } from "../../../shared/lib/error/MyError";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { createPortal } from "react-dom";
import classes from './receiptPending.module.scss'
import { MyButton } from "../../../shared/ui/button";
import { OpenContainer } from "../../../features/openContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { FEATURES, hasFeature } from "../../../entities/my";
import { useAppSelector } from "../../../app/store/store";
import { RECEIPT_HEADER_ID, RECEIPT_SAVED_EVENT } from "../../../shared/lib/const/receiptEvents";

interface IProps {
    inline?: boolean;
    refreshKey?: number;
    collapsible?: boolean;
}

export const ReceiptPending: FC<IProps> = ({inline = false, refreshKey = 0, collapsible = false}) => {

    const [pending, setPending] = useState<boolean>(false)
    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [receiptVersion, setReceiptVersion] = useState(0)
    const {setGlobalMessage} = useGlobalMessageActions()    
    const {setIsAuth} = useMyActions()
    const router = useNavigate()
    const {pathname} = useLocation()
    const [headerTarget, setHeaderTarget] = useState<HTMLElement | null>(null)
    const {my} = useAppSelector(state => state.myReducer)
    const canReadPayouts = my.role === 'tutor' && hasFeature(my, FEATURES.TUTORS.PAYOUTS_READ, my.id)

    useEffect(() => {
        if(!inline) setHeaderTarget(document.getElementById(RECEIPT_HEADER_ID))
    }, [inline, pathname])

    const check = async () => {
        try{
            const isPending = await tutorService.receiptPending()
            setPending(isPending)
            setIsChecked(true)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при получении информации о задолжности выгрузки чека', type: 'error'})
            }
        }
        finally{}
    }

    useEffect(() => {
        if(canReadPayouts){
            check()
        }
    }, [refreshKey, receiptVersion, canReadPayouts])

    useEffect(() => {
        const refresh = () => setReceiptVersion(value => value + 1)
        window.addEventListener(RECEIPT_SAVED_EVENT, refresh)
        return () => window.removeEventListener(RECEIPT_SAVED_EVENT, refresh)
    }, [])

    if(!canReadPayouts){
        return null
    }

    const toFinance = () => {
        setPending(false)
        router('/tutor_finance')
    }

    const statusText = <section className={classes.inlineText}>
        {!isChecked
            ? 'Проверяем наличие задолженности по чекам...'
            : pending
                ? 'Есть задолженность: нужно прикрепить чек по выплатам.'
                : 'Задолженности по чекам сейчас нет.'}
    </section>

    return (
        inline
            ?
        <section className={classes.inlineCard + (pending ? ` ${classes.inlinePending}` : ` ${classes.inlineSuccess}`)}>
            {collapsible ? <OpenContainer title="Статус чеков по выплатам" defaultOpen>
                {statusText}
            </OpenContainer> : <>
                <section className={classes.inlineTitle}>Статус чеков по выплатам</section>
                {statusText}
            </>}
        </section>
            :
        pending
            ?
        <>
        {headerTarget && createPortal(
            <strong className={classes.headerWarning} role="status">
                Задолжность! Вам нужно загрузить чек!
            </strong>, headerTarget
        )}
        {createPortal(
            <section className={classes.container}>
                <section className={classes.content}>
                    <section className={classes.text}>
                        Задолжность! Вам нужно загрузить чек!
                    </section>
                    <section className={classes.button}>
                        <MyButton onClick={toFinance}>
                            Перейти к выплатам
                        </MyButton>
                    </section>
                </section>
            </section>,
            document.body
        )}
        </>
            :
        <></>
    )
}
